export default "__VITE_ASSET__DhSICqjw__"